// language.js
export const translations = {
  en: {
    customerItemCatalogue: "Customer Part Database",
    searchFilters: "Search Filters",
    logout: "Logout",
    filterBy: "Filter by",
    exportToCSV: "Export to CSV",
    customerName: "Customer Name",
    customerId: "Customer ID",
    rfc: "RFC",
    itemNumber: "Item #",
    supplierItemNumber: "Supplier Item #",
    mxHts: "MX HTS",
    descriptionSpa: "Description SPA",
    descriptionEng: "Description ENG",
    usHts: "US HTS",
    umc: "UMC",
    umf: "UMF",
    unitPrice: "Unit Price",
    tlc: "TLC",
    ps: "PS",
    satClave: "SAT Clave",
    satUm: "SAT UM",
    embalaje: "Embalaje",
    matPeligroso: "Mat Peligroso",
    umPeso: "UM Peso",
    createdAt: "Created At",
    updatedAt: "Updated At",
    crossedParts: "Crossed Report",
    viewCrossedParts: "Cross Report",
    itemDetails: "Item Details",
    itemInformation: "Item Information",
    customer: "Customer",
    viewCrossedPartsHistory: "Cross Report",
    actions: "Actions",
  },
  es: {
    customerItemCatalogue: "Catálogo de Artículos del Cliente",
    searchFilters: "Filtros de Búsqueda",
    logout: "Cerrar sesión",
    filterBy: "Filtrar por",
    exportToCSV: "Exportar a CSV",
    customerName: "Nombre del Cliente",
    customerId: "ID del Cliente",
    rfc: "RFC",
    itemNumber: "Número de Artículo",
    supplierItemNumber: "Número de Artículo del Proveedor",
    mxHts: "HTS MX",
    descriptionSpa: "Descripción ESP",
    descriptionEng: "Descripción ING",
    usHts: "HTS US",
    umc: "UMC",
    umf: "UMF",
    unitPrice: "Precio Unitario",
    tlc: "TLC",
    ps: "PS",
    satClave: "Clave SAT",
    satUm: "UM SAT",
    embalaje: "Embalaje",
    matPeligroso: "Material Peligroso",
    umPeso: "Peso UM",
    createdAt: "Creado el",
    updatedAt: "Actualizado el",
    crossedParts: "Reporte Cruce",
    viewCrossedParts: "Reporte Cruce",
    itemDetails: "Detalles Item",
    itemInformation: "Info Item",
    customer: "Cliente",
    viewCrossedPartsHistory: "Reporte Cruce",
    actions: "Acciones",
  },
};
